const EnumKeysHelper = (e: any): string[] => {
    return Object.keys(e).filter((key) => typeof e[key] === "number");
};

const EnumValuesHelper = (e: any): string[] => {
    return Object.keys(e)
        .filter((key) => typeof e[key] === "number")
        .map((key) => e[key]);
};

export {EnumKeysHelper, EnumValuesHelper};
